import React from "react";
import "./Feat.css";

import Popover from "react-bootstrap/Popover";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import ChatIcon from "@mui/icons-material/ChatSharp";
import PeopleAlt from "@mui/icons-material/PeopleAlt";

const statisticStyle = {
  marginTop: "0px",
  marginBottom: "0px",
  marginRight: "25%",
  marginLeft: "25%",
};

const headerStyle = {
  marginTop: "10px",
  marginBottom: "0px",
};

const Feat = ({
  name,
  tier,
  description,
  cooldown,
  activation_time,
  recovery_time,
  explanation,
  image,
  characters_list = '',
}) => {

  const characters = characters_list ? characters_list.split(', ') : [];
  
  return (
    <div className="feat">
      
      <div className="feat-name-and-description">
        <div className="feat-name">
          <div>{name}</div>
          <div>{tier}</div>
          <hr style={headerStyle} />
        </div>
        <div className="feat-description">
        {image && <img src={"feats/"+image+".png"} alt="featImage" className='featImage' draggable="false"/>}
          <div className="feat-description-explanation">{description}</div>
        </div>
      </div>
      <div className="feat-statistic-container">

        {cooldown !== null ? (
          <div>
            <hr style={statisticStyle} />
            <div className="feat-statistic-heading">Cooldown</div>
            <div>{cooldown ? cooldown + " seconds" : "N/A"}</div>
          </div>
        ) : (
          ""
        )}
        {activation_time !== null ? (
          <div>
            <hr style={statisticStyle} />
            <div className="feat-statistic-heading">Activation Time</div>
            <div>{activation_time ? activation_time + "ms" : "N/A"}</div>
          </div>
        ) : (
          ""
        )}
        {recovery_time !== null ? (
          <div>
            <hr style={statisticStyle} />
            <div className="feat-statistic-heading">Recovery Time</div>
            <div>{recovery_time ? recovery_time + "ms" : "N/A"}</div>
          </div>
        ) : (
          ""
        )}
        {recovery_time !== null ||
        activation_time !== null ||
        cooldown !== null ? (
          <div>
            <hr style={statisticStyle} />
          </div>
        ) : (
          ""
        )}
      </div>
      <div className="feat-footer">  {/* New wrapper for icons */}
        <OverlayTrigger
          trigger="click"
          rootClose
          placement="top"
          overlay={
            <Popover>
              <Popover.Header as="h3">{"Feat Assessment"}</Popover.Header>
              <Popover.Body>
                {explanation ||
                  "We are still assessing this feat - it's coming Soon™️"}
              </Popover.Body>
            </Popover>
          }
        >
          <ChatIcon fontSize="large" className="assessment-icon" />
        </OverlayTrigger>
        <OverlayTrigger
          trigger="click"
          rootClose
          placement="top" 
          overlay={
            <Popover>
              <Popover.Header as="h3">{"Feat Availability"}</Popover.Header>
              <Popover.Body>
                {characters.length === 1 ? (
                  <div>This feat is exclusively available to {characters_list}.</div>
                ) : characters.length > 1 ? (
                  <div>
                    This feat is available to{' '}
                    {characters.slice(0, -1).join(', ') + 
                    (characters.length > 2 ? ', and ' : ' and ') + 
                    characters[characters.length - 1]}.
                  </div>
                ) : (
                  "No characters have access to this feat."
                )}
              </Popover.Body>
            </Popover>
          }
        >
          <PeopleAlt fontSize="large" className="characters-icon" />
        </OverlayTrigger>
      </div>
    </div>
  );
};

export default Feat;
